import React from "react";
import "./articles.style.css";

const Article = ({ item }) => {
  return (
    <article
      className="article-container"
      itemScope
      itemType="https://schema.org/Article"
    >
      {/* Invisible structured metadata */}
      <meta itemProp="headline" content={item.title} />
      <meta itemProp="mainEntityOfPage" content={item.link} />
      <meta itemProp="author" content="Swagat Vyas" />

      {item.logo && (
        <img
          className="article-logo"
          src={item.logo}
          alt={`${item.title} - Article featuring Swagat Vyas`}
          itemProp="image"
          loading="lazy"
        />
      )}

      <p className="article-desc" itemProp="description">
        {item.title}
      </p>

      <button className="article-link">
        <a
          href={item.link}
          target="_blank"
          rel="noreferrer"
          itemProp="url"
          aria-label={`Read full article: ${item.title}`}
        >
          Read More
        </a>
      </button>
    </article>
  );
};

export default Article;
